export default {
  title: 'Gestionnaire KeyPal',
  desc: 'Votre outil de mise à jour du firmware KeyPal',
  download: 'Télécharger KeyPal Bridge',
  onLine: 'Mise à jour en ligne',
  goDesktop: 'Veuillez utiliser un ordinateur pour effectuer l’opération',
  macTitle: 'Mac(Puce Apple Silicon)',
  question_1: 'Comment mettre à jour KeyPal via l’application de bureau ?',
  question_2: 'Comment mettre à jour via le web ?',
}
